import { ApplicationEnum } from '@landr/core.models';
import packageJson from '../../package.json';

export const ApplicationVersion = packageJson && packageJson.version;
export const ApplicationName = ApplicationEnum.SamplesIngestionWizard;
